import React from 'react'
import PropTypes from 'prop-types'
import { Button, Dialog, DialogActions, DialogContent, useMediaQuery } from '@mui/material'
import { MODAL_STYLES } from 'asterX-UI/theme.constant'
import ModalTitle from 'asterX-UI/Modals/ModalTitle'
import { GRAY_COLORS } from 'asterX-UI/colors.constant'

const InfoModal = ({ open, onClose, variant = '', title = '', btnText = 'OK', isButtonHidden, maxWidth, ...other }) => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down('sm'))

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={isMobile ? 'sm' : 'md'}
      fullWidth
      sx={{
        '& .MuiPaper-root': {
          maxWidth: maxWidth || 'sm',
          backgroundColor: variant === 'dark' ? GRAY_COLORS[900] : GRAY_COLORS[100]
        }
      }}
      {...other}
    >
      <ModalTitle onClose={onClose} variant={variant} style={{ color: GRAY_COLORS[800] }}>
        {title}
      </ModalTitle>
      <DialogContent>{other.children}</DialogContent>
      {!isButtonHidden && (
        <DialogActions>
          <Button variant="outlined" fullWidth onClick={onClose}>
            {btnText}
          </Button>
        </DialogActions>
      )}
    </Dialog>
  )
}

InfoModal.propTypes = {
  title: PropTypes.string,
  open: PropTypes.bool,
  onClose: PropTypes.func,
  variant: PropTypes.oneOf(MODAL_STYLES.variant),
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.string])
}

export default InfoModal
